import { createSlice } from '@reduxjs/toolkit';

import type { DroneResponse } from './types';

export const slice = createSlice({
    initialState: {
        aircrafts: undefined as DroneResponse[] | undefined,
        aircraftsWithFlightController: undefined as DroneResponse[] | undefined
    },

    name: 'useAircraft',

    reducers: {
        aircrafts: (state, action) => {
            state.aircrafts = action.payload;
        },

        aircraftsWithFlightController: (state, action) => {
            state.aircraftsWithFlightController = action.payload;
        }
    }
});

export default slice.reducer;
